module.exports = __webpack_public_path__ + "public/files/img/error.700bd717.svg";